import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import "./WhyDialog.css";

interface WhyDialogProps {
  visible: boolean;
  initialWhy?: string;
  onSave: (why: string) => void;
  onHide: () => void;
}

const WhyDialog: React.FC<WhyDialogProps> = ({
  visible,
  initialWhy = "",
  onSave,
  onHide,
}) => {
  const [whyText, setWhyText] = useState(initialWhy);

  useEffect(() => {
    setWhyText(initialWhy);
  }, [initialWhy, visible]);

  const handleSave = () => {
    onSave(whyText);
    onHide();
  };

  const handleCancel = () => {
    setWhyText(initialWhy);
    onHide();
  };

  return (
    <Dialog
      visible={visible}
      onHide={handleCancel}
      {...({
        onContextMenu: (e: React.MouseEvent) => e.stopPropagation(),
        onDoubleClick: (e: React.MouseEvent) => e.stopPropagation(),
        onClick: (e: React.MouseEvent) => e.stopPropagation(),
      } as any)}
      header={
        <div>
          <div
            style={{
              fontSize: "1.25rem",
              fontWeight: "bold",
              marginBottom: "0.25rem",
            }}
          >
            Why?
          </div>
          <div
            style={{
              fontSize: "1rem",
              color: "#666",
              fontWeight: "normal",
              marginBottom: "0.25rem",
            }}
          >
            Who is this for? What makes this valuable?
          </div>
          <div
            style={{
              fontSize: "0.875rem",
              color: "#999",
              fontWeight: "normal",
            }}
          >
            - you can hide this option in Settings
          </div>
        </div>
      }
      style={{ width: "500px", height: "400px" }}
      closable={true}
      modal
      footer={
        <div>
          <Button
            label="Cancel"
            icon="pi pi-times"
            onClick={handleCancel}
            className="p-button-text"
          />
          <Button label="Save" icon="pi pi-check" onClick={handleSave} />
        </div>
      }
    >
      <div
        className="why-dialog-content"
        style={{ display: "flex", flexDirection: "column", height: "100%" }}
        onContextMenu={(e) => e.stopPropagation()}
        onDoubleClick={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
      >
        <InputTextarea
          value={whyText}
          onChange={(e) => setWhyText(e.target.value)}
          placeholder="fill in your own why..."
          style={{ width: "100%", flex: 1, minHeight: "160px" }}
          autoFocus
        />
      </div>
    </Dialog>
  );
};

export default WhyDialog;
